import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { storeEvent, getEvents } from '../../shared/ducks/events';

const MAX_RETRIES = 10;

class EventSourceComp extends React.Component {
    componentDidMount() {
        let reconnectCount = 0;
        const handleEvent = event => {
            this.props.storeEvent(JSON.parse(event.data));
        };

        this.eventSource = new EventSource(this.props.url);
        this.eventSource.onopen = () => console.debug('Event stream opened');
        this.eventSource.onclose = () => console.debug('Event stream closed');
        this.eventSource.onmessage = e => {
            // ...
        };
        this.props.types.forEach(type =>
            this.eventSource.addEventListener(type, handleEvent, false)
        );
        this.eventSource.onerror = e => {
            // Supported by Chrome & Firefox only...
            const src = e.srcElement || e.originalTarget;

            if (src) {
                if (src.readyState === EventSource.CLOSED) {
                    console.debug('Error occured, closing connection');
                } else if (src.readyState === EventSource.CONNECTING) {
                    console.debug('Trying to connect to event stream');
                    reconnectCount++;
                    if (reconnectCount === MAX_RETRIES) {
                        this.eventSource.close();
                        console.debug(
                            `[EventSource] Failed to reconnect after 10 tries, closing ${
                                this.props.url
                            }`
                        );
                    }
                }
            } else {
                console.debug('Event stream error', e);
            }
        };
    }

    componentWillUnmount() {
        this.eventSource.close();
    }

    render() {
        return null;
    }
}

EventSourceComp.propTypes = {
    url: PropTypes.string.isRequired,
};

EventSourceComp.defaultProps = {
    types: ['message'],
};

export default connect(state => ({ events: getEvents(state) }), { storeEvent })(EventSourceComp);
